/* Top-Hardware Zusatzgarantie (Paket 6, 29.08.2026)
   Teil 1: Pills auf der Produktseite, Garantie als eigene Warenkorbzeile nachlegen.
   Teil 2: Warenkorb-Waechter, entfernt Garantien ohne zugehoeriges Geraet.
   Kopplung ausschliesslich ueber die Eigenschaften der Garantiezeile:
   "Für Gerät" (sichtbar) und "_th_geraet_key" (Varianten-ID des Geraets, unsichtbar).
   01.09.2026: Zusammenfassung mit Geraet, Zusatzgarantie und Total, sobald eine
   Garantie gewaehlt ist (Wunsch Burim). Der grosse Preis oben bleibt unveraendert,
   weil dieser Wert im Google-Shopping-Eintrag steht. Waehrungsformat aus
   shop.money_format, Geraetepreise aus dem JSON im Snippet, nichts hartcodiert.
   01.09.2026 zweite Runde: die vier deutschen Saetze kommen jetzt als
   data-t-Attribute aus dem Snippet, das sie aus locales/*.json zieht.
   Vorher blieb der Kasten auf /en/ und /fr/ deutsch. */
(function () {
  'use strict';
  var WARRANTY_HANDLE = (window.thWarranty && window.thWarranty.handle) || 'top-hardware-garantie';
  var lastForm = null;

  function cartEl() { return document.querySelector('cart-notification') || document.querySelector('cart-drawer'); }
  function sectionIds() { var c = cartEl(); return c && c.getSectionsToRender ? c.getSectionsToRender().map(function (s) { return s.id; }) : []; }

  /* ---------- Teil 1: Widget ---------- */
  var widget = document.querySelector('[data-th-warranty]');
  var selectedId = '';

  /* ---------- Zusammenfassung: Geraet + Zusatzgarantie = Total ---------- */
  function readJson(sel) {
    var el = widget && widget.querySelector(sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  var moneyFormat = (widget && widget.getAttribute('data-money-format')) || 'CHF {{amount}}';
  function tt(name, fallback) {
    var v = widget && widget.getAttribute('data-t-' + name);
    return v || fallback;
  }
  var devicePrices = null, warrantyVariants = null;
  function groupNumber(cents, precision, thousands, decimal) {
    var v = (Math.round(cents) / 100).toFixed(precision);
    var parts = v.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
  }
  function formatMoney(cents) {
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount_no_decimals': return groupNumber(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return groupNumber(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return groupNumber(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return groupNumber(cents, 2, "'", '.');
        case 'amount_with_space_separator': return groupNumber(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return groupNumber(cents, 0, ' ', '.');
        case 'amount_with_period_and_space_separator': return groupNumber(cents, 2, ' ', '.');
        default: return groupNumber(cents, 2, ',', '.');
      }
    });
  }
  function deviceVariantId() {
    var form = widget && widget.closest('form');
    var input = (form || document).querySelector('input[name="id"]');
    return input ? String(input.value) : '';
  }
  function deviceQuantity() {
    var form = widget && widget.closest('form');
    var q = (form || document).querySelector('input[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return n > 0 ? n : 1;
  }
  function setText(sel, value) {
    var el = widget.querySelector(sel);
    if (el) el.textContent = value;
  }
  function renderSummary() {
    if (!widget) return;
    var box = widget.querySelector('[data-th-warranty-summary]');
    if (!box) return;
    if (!selectedId) { box.hidden = true; return; }
    if (devicePrices === null) devicePrices = readJson('[data-th-device-prices]') || {};
    if (warrantyVariants === null) warrantyVariants = readJson('[data-th-warranty-data]') || [];
    var wv = null;
    for (var i = 0; i < warrantyVariants.length; i++) {
      if (String(warrantyVariants[i].id) === String(selectedId)) { wv = warrantyVariants[i]; break; }
    }
    var devPrice = devicePrices[deviceVariantId()];
    if (!wv || devPrice === undefined || devPrice === null) { box.hidden = true; return; }
    var qty = deviceQuantity();
    var dev = devPrice * qty;
    var war = wv.price * qty;
    var devLabel = qty > 1
      ? tt('device-qty', 'Ger\u00e4t, __N__ St\u00fcck').replace('__N__', qty)
      : tt('device', 'Ger\u00e4t');
    setText('[data-th-sum-device-label]', devLabel);
    setText('[data-th-sum-warranty-label]', (tt('warranty', 'Zusatzgarantie') + ' ' + (wv.title || '')).trim());
    setText('[data-th-sum-device]', formatMoney(dev));
    setText('[data-th-sum-warranty]', '+ ' + formatMoney(war));
    setText('[data-th-sum-total]', formatMoney(dev + war));
    /* Versandzeile unter dem Total (02.09.2026, Wunsch von Burim).
       Die Karte sagte "Total", obwohl der Versand noch dazukam.
       Verglichen wird die SUMME aus Geraet und Garantie, nicht der Geraetepreis.
       BELEGT am 02.09.2026 ueber /cart/shipping_rates.json, Zone Schweiz 5722:
         Geraet 349.00 allein                  -> Standard-Versand CHF 15.00
         Geraet 315.00 allein                  -> Standard-Versand CHF 15.00
         Geraet 349.00 + Garantie 39.00 = 388  -> Standard-Versand CHF  0.00
       Vom Klienten im echten Checkout bestaetigt: 299.00 + 89.00 = 388.00 zeigt
       "Versand KOSTENLOS". Shopify zaehlt die Garantie also zur Gratis-Schwelle,
       obwohl sie requires_shipping false traegt. */
    var freeAt = parseInt(widget.getAttribute('data-free-shipping-cents') || '0', 10);
    var versandGratis = freeAt > 0 && (dev + war) >= freeAt;
    setText('[data-th-sum-shipping]', versandGratis
      ? tt('ship-free', 'gratis')
      : tt('ship-checkout', 'wird im Checkout berechnet'));
    /* Das Wort haengt am Versand: nur wenn der Versand gratis ist, ist der Betrag
       wirklich das Total. Sonst heisst die Zeile Zwischensumme, sonst behaupten
       wir eine Endsumme, die noch waechst (Hinweis Agron 02.09.2026). */
    setText('[data-th-sum-total-label]', versandGratis
      ? tt('total', 'Total')
      : tt('subtotal', 'Zwischensumme'));
    box.hidden = false;
  }

  function setLocked(locked) {
    var form = widget && widget.closest('form');
    var scope = form || document;
    scope.querySelectorAll('.shopify-payment-button').forEach(function (b) { b.classList.toggle('th-warranty-locked', locked); });
    if (form) form.classList.toggle('th-warranty-locked', locked);
    renderSummary();
  }
  function select(id) {
    selectedId = id || '';
    widget.querySelectorAll('.th-warranty__pill').forEach(function (p) {
      var on = (p.getAttribute('data-th-warranty-id') || '') === selectedId;
      p.classList.toggle('is-active', on);
      p.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    setLocked(!!selectedId);
  }
  if (widget) {
    widget.querySelectorAll('.th-warranty__pill').forEach(function (p) {
      p.addEventListener('click', function () { select(p.getAttribute('data-th-warranty-id')); });
    });
    /* Variantenwechsel und Mengenaenderung: der Varianten-Waehler liegt ausserhalb des
       Formulars und setzt input[name="id"] per Javascript, ein change-Ereignis auf dem
       Feld selbst ist deshalb nicht verlaesslich. Darum auf Dokumentebene mithoeren. */
    ['change', 'input', 'click'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(renderSummary, 60); }, true);
    });
    document.addEventListener('submit', function (e) {
      if (e.target && e.target.matches && e.target.matches('form[data-type="add-to-cart-form"]')) lastForm = e.target;
    }, true);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
        if (!data || data.source !== 'product-form' || !selectedId || !lastForm) return;
        var idInput = lastForm.querySelector('input[name="id"]');
        if (!idInput || String(idInput.value) !== String(data.productVariantId)) return;
        var qtyEl = lastForm.querySelector('input[name="quantity"]');
        var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
        var props = {};
        props['Für Gerät'] = widget.getAttribute('data-product-title') || document.title;
        props['_th_geraet_key'] = String(data.productVariantId);
        var body = { items: [{ id: parseInt(selectedId, 10), quantity: qty, properties: props }], sections: sectionIds(), sections_url: location.pathname };
        fetch(window.routes.cart_add_url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) throw new Error(res.description || res.message || 'Fehler');
            var c = cartEl(); if (c && c.renderContents) setTimeout(function () { c.renderContents(res); }, 50);
            select('');
          })
          .catch(function (err) {
            var w = lastForm.querySelector('.product-form__error-message-wrapper');
            if (w) { w.hidden = false; var m = w.querySelector('.product-form__error-message'); if (m) m.textContent = tt('add-error', 'Zusatzgarantie konnte nicht hinzugefügt werden: __MSG__').replace('__MSG__', err.message); }
          });
      });
    }
  }

  /* ---------- Teil 2: Warenkorb-Waechter ---------- */
  var guarding = false;
  function guard() {
    if (guarding) return; guarding = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var items = cart.items || [];
      var devices = {};
      items.forEach(function (it) { if (it.handle !== WARRANTY_HANDLE) devices[String(it.variant_id)] = (devices[String(it.variant_id)] || 0) + it.quantity; });
      var fixes = [];
      items.forEach(function (it) {
        if (it.handle !== WARRANTY_HANDLE) return;
        var key = it.properties && it.properties._th_geraet_key ? String(it.properties._th_geraet_key) : '';
        var have = key ? (devices[key] || 0) : 0;
        if (have <= 0) fixes.push({ id: it.key, quantity: 0 });
        else if (it.quantity > have) fixes.push({ id: it.key, quantity: have });
        if (key && have > 0) devices[key] = Math.max(0, have - it.quantity);
      });
      if (!fixes.length) { guarding = false; return; }
      var chain = Promise.resolve();
      fixes.forEach(function (f) {
        chain = chain.then(function () {
          return fetch(window.routes.cart_change_url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: f.id, quantity: f.quantity, sections: sectionIds(), sections_url: location.pathname }) }).then(function (r) { return r.json(); });
        });
      });
      chain.then(function (last) {
        try { sessionStorage.setItem('th_warranty_notice', '1'); } catch (e) {}
        if (document.getElementById('main-cart-items')) { location.reload(); return; }
        var c = cartEl(); if (c && c.renderContents && last) c.renderContents(last);
        showNotice();
      }).catch(function () {}).then(function () { guarding = false; });
    }).catch(function () { guarding = false; });
  }
  function showNotice() {
    var host = document.getElementById('main-cart-items') || document.querySelector('cart-drawer .drawer__inner') || document.querySelector('cart-drawer');
    if (!host || host.querySelector('.th-warranty__cart-note')) return;
    var n = document.createElement('p'); n.className = 'th-warranty__cart-note';
    n.textContent = (window.thWarranty && window.thWarranty.cartRemoved)
      || tt('cart-removed', 'Die Zusatzgarantie wurde entfernt, weil das zugeh\u00f6rige Ger\u00e4t nicht mehr im Warenkorb ist.');
    host.insertBefore(n, host.firstChild);
  }
  try { if (sessionStorage.getItem('th_warranty_notice') === '1' && document.getElementById('main-cart-items')) { sessionStorage.removeItem('th_warranty_notice'); showNotice(); } } catch (e) {}
  /* Ausloeser. assets/cart.js dieses Themes sendet KEIN cartUpdate-Ereignis,
     deshalb zusaetzlich ein Beobachter auf dem Warenkorb-Bereich. */
  var guardTimer = null;
  function scheduleGuard(delay) { clearTimeout(guardTimer); guardTimer = setTimeout(guard, delay || 500); }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, function () { scheduleGuard(400); });
  function watch(el) { if (el && window.MutationObserver) new MutationObserver(function () { scheduleGuard(500); }).observe(el, { childList: true, subtree: true }); }
  function boot() {
    scheduleGuard(300);
    watch(document.getElementById('main-cart-items'));
    var d = document.querySelector('cart-drawer');
    watch(d);
    if (d) d.addEventListener('click', function () { scheduleGuard(400); }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
